import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import IssuerAccrualScheduleReportCriteria from "./IssuerAccrualScheduleReportCriteria";
import AccrualScheduleHelper from "./AccrualScheduleHelper";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";

@NeoReport("IssuerAccrualScheduleReport", { category: ReportCategory.IssuerReports })
export default class IssuerAccrualScheduleReport extends Report<IssuerAccrualScheduleReportCriteria> {

    constructor(
        private issuerApiClient = AppService.get(DomainTypes.ApiClients.Issuer)
    ) {
        super(IssuerAccrualScheduleReportCriteria);
    }

    public renderCriteria() {

        return <div>
            <Neo.FormGroup bindContext={this.criteria.meta.issuerId}>
                <Neo.AutoCompleteDropDown
                    bind={this.criteria.meta.issuerId}
                    bindDisplay={this.criteria.meta.issuerName}
                    itemSource={this.issuerApiClient.getIssuerLookups} />
            </Neo.FormGroup>
        </div>;
    }

    public getDefaultGridLayout(criteria?: IssuerAccrualScheduleReportCriteria | undefined, propertyKey?: string | undefined) {
        return AccrualScheduleHelper.getLayout();
    }
}